export const resolveResourceUrl = (
  value: string | null | undefined,
  baseUrl: string,
) => {
  if (!value) return "";

  try {
    const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
    return new URL(value, normalizedBaseUrl).toString();
  } catch {
    return value;
  }
};
